import { axios } from "../axios.instance";

export type TranslateMessageRequest = {
  messageId: string;
  targetLanguageCode: string;
};

export type TranslateMessageResponse = {
  translation: string;
};

export const translateMessage = async ({ messageId, ...body }: TranslateMessageRequest) => {
  try {
    const { data } = await axios.post(`/chats/messages/${messageId}/translate`, body);

    return data as TranslateMessageResponse;
  } catch (error) {}
};
